import { createAsyncActions } from './utils'

const reducer = 'IOT'

const {
  action: initializeIot,
  actionSuccess: initializeIotSuccess,
  actionFail: initializeIotFail
} = createAsyncActions(reducer, 'INITIALIZE')

const {
  action: onMessage,
  actionSuccess: onMessageSuccess,
  actionFail: onMessageFail
} = createAsyncActions(reducer, 'ON_MESSAGE')

export {
  initializeIot,
  initializeIotFail,
  initializeIotSuccess,
  onMessage,
  onMessageFail,
  onMessageSuccess
}
